export const blockCountQueryParameter = "bc";
export const lastShownKey = "new_tab_last_shown";
export const coolDownPeriodKey = "new_tab_cool_down";
